import { Dropdown } from '@contexts/dropdowns/types';
import { UsersDropdown } from '@services/dropdowns/types';

export const isManuallyAdded = (
  assetId: string,
  foremanId: string,
  fieldUsers: Dropdown<UsersDropdown[]>,
) => {
  if (!foremanId || !fieldUsers.options.length) return true;

  return !fieldUsers.options
    .find((el) => el.id === foremanId)
    ?.assetMembers?.some((el) => el.id === assetId);
};
